import { SearchRoundedIcon, TextField } from '@shared/components';
import debounce from 'lodash/debounce';
import { useCallback } from 'react';

import { useUserManagementListSearchParams } from '../../hooks';

export default function UserSearchBox() {
  const [{ search }, { changeSearch }] = useUserManagementListSearchParams();

  const debouncedSearch = useCallback(
    debounce((searchString) => {
      changeSearch(searchString);
    }, 700),
    [],
  );

  return (
    <TextField
      placeholder='ค้นหาผู้ใช้...'
      name='search'
      slotProps={{
        input: {
          startAdornment: <SearchRoundedIcon sx={{ color: (theme) => theme.palette.grey[500] }} />,
        },
      }}
      sx={{ width: '318px' }}
      defaultValue={search}
      onChange={(event) => {
        debouncedSearch(event.target.value);
      }}
    />
  );
}
